import { render, staticRenderFns } from "./serviceprice.vue?vue&type=template&id=2bf25cbe&"
import script from "./serviceprice.vue?vue&type=script&lang=js&"
export * from "./serviceprice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf25cbe')) {
      api.createRecord('2bf25cbe', component.options)
    } else {
      api.reload('2bf25cbe', component.options)
    }
    module.hot.accept("./serviceprice.vue?vue&type=template&id=2bf25cbe&", function () {
      api.rerender('2bf25cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OvYqGW732Ldl/JS/serviceprice.vue"
export default component.exports